<template>
  <div class="speltselec flex_start wrap">
    <div
      class="item"
      @click="clisel({ name: '全部专题', id: 0 })"
      :class="{ lltiteact: 0 == selewtindex }"
    >
      全部专题
    </div>
    <div
      class="item"
      v-for="(item, index) in problemlist"
      :key="index"
      @click="clisel(item)"
      :class="{ lltiteact: item.id == selewtindex }"
    >
      {{ item.cat_name }}
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    // selewtindex: 0,
    problemlist: [],
  }),
  beforeMount() {
    this.getproblem();
  },
  computed: {
    selewtindex() {
      return this.$store.state.laws.fljjxx.id;
    },
  },
  methods: {
    clisel(item) {
      // this.selewtindex = item.id;
      this.$store.commit("laws/upfljjxx", { name: item.cat_name, id: item.id });
    },
    getproblem() {
      this.$http.laws.getlawify().then((res) => {
        this.problemlist = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.speltselec {
  width: 100%;
  padding: 3px 20px 20px;
  .item {
    text-align: center;
    padding: 4px 8px;
    border-radius: 20px;
    color: #000;
    margin-right: 14px;
    margin-top: 20px;
    cursor: pointer;
    position: relative;
    &:hover {
      background: #0465ea;
      color: #fff;
    }
    &.lltiteact {
      background: #0465ea;
      color: #fff;
    }
  }
}
</style>